export default __webpack_public_path__ + "static/media/logo_login.42e54e1e.png";